// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4221":"c6c2f59e","5971":"a84cf73e","7684":"e7b3dcce","7850":"ec9201e1"}[chunkId] + ".chunk.css";
};